import './styles.css';
import { useState, useEffect } from "react";
import { createColumnHelper, flexRender, getCoreRowModel, useReactTable, getFilteredRowModel, getSortedRowModel } from '@tanstack/react-table';
export function Table(props) {
    const [columnFilters, setColumnFilters] = useState([]);
    const [sorting, setSorting] = useState([]);
    const [totalData, setTotalData] = useState(props.data);
    const [columnsData, setColumnsData] = useState([]);
    const columnHelper = createColumnHelper();
    let customTable = useReactTable({
        data: props.data,
        columns: props.columns,
        getCoreRowModel: getCoreRowModel(),
        getFilteredRowModel: getFilteredRowModel(), // <-- Essential for filtering
        onColumnFiltersChange: setColumnFilters, // <-- Update filter state
        onSortingChange: setSorting,// <-- Update sorting state
        getSortedRowModel: getSortedRowModel(), // <-- Essential for sorting
        state: { columnFilters, sorting }, // <-- Current filter state
    })
    useEffect(
        () => { }, [props]
    );
    return (
        <div>
            <div className='filterTableDiv'>
                <span>Filter by:</span>
                {props.columns.map(
                    (item, index) => {
                        return (index > 0 && index < props.columns.length - 1) && (
                            <input
                                id={index}
                                key={item.id}
                                type="text"
                                value={customTable?.getColumn(item.id)?.getFilterValue() ?? ''}
                                onChange={(e) => customTable?.getColumn(item.id)?.setFilterValue(e.target.value)}
                                placeholder={item.id}
                            />
                        )
                    }
                )
                }
                {/* <span className='totalSpan'>{customTable?.getRowModel()?.rows?.length} ... {totalData}</span> */}
            </div>
            <table className="dashboardTable">
                <thead>

                    {
                        customTable.getHeaderGroups().map((headerGroup, index) => (
                            <tr key={index}>
                                {headerGroup.headers.map((header, index) => (
                                    <th key={index} onClick={header.column.getToggleSortingHandler()}>
                                        {
                                            header.isPlaceholder
                                                ? null
                                                : flexRender(header.column.columnDef.header, header.getContext())
                                        }
                                        {{
                                            asc: '🔼',
                                            desc: '🔽',
                                        }[header.column.getIsSorted()] ?? null}
                                    </th>
                                ))}
                            </tr>
                        ))
                    }
                </thead>
                <tbody>

                    {
                        customTable.getRowModel().rows.map((row, index) => (
                            <tr key={index}>
                                {
                                    row.getVisibleCells().map((cell, index) => (
                                        <td key={index}>
                                            {
                                                flexRender(cell.column.columnDef.cell, cell.getContext())
                                            }
                                        </td>
                                    ))
                                }
                            </tr>
                        ))
                    }
                </tbody>
            </table>
        </div>
    )
}
export function CustomTable(props) {
    return (
        <div>
            <table className="dashboardTable">
                <thead>
                    <tr>
                        {
                            props.columns.map(
                                (item, index) =>
                                    <th key={index}>
                                        {item.id}
                                    </th>

                            )
                        }
                    </tr>
                </thead>
                <tbody>
                    {props.data.map(
                        (item, index) =>
                            <tr key={index}>
                                {
                                    Object.values(item).map(
                                        (element, index) => {
                                            return (
                                            props.columns[index].id ==='email' ?
                                                <td key={index}><a href={'/member/' + element} >{element}</a> </td>
                                                : <td key={index}>{element}</td>
                                            )
                                        }
                                    )
                                }
                            </tr>
                    )
                    }
                </tbody>

            </table>
        </div>
    )
}